import { WeekDaysEnum } from '../core/enum/week-days.enum';

/*@deprecated use LogoDirective instead */
export const MAIN_LOGO_URL = '/assets/images/fit-a-coach-logo.png';
/*@deprecated use LogoDirective instead */
export const MAIN_INLINE_LOGO_URL =
  '/assets/images/fit-a-coach-inline-logo.png';
/*@deprecated use LogoDirective instead */
export const MAIN_WHITE_LOGO_URL = '/assets/images/fit-a-coach-logo-white.png';

export const AVATAR_PLACEHOLDER_URL = '/assets/images/avatar-placeholder.png';

export const FIT_A_COACH_ICON_URL = '/assets/images/fac/icon.png';

export const WEEKDAY_LABELS: Record<WeekDaysEnum, string> = {
  [WeekDaysEnum.Monday]: 'Lundi',
  [WeekDaysEnum.Tuesday]: 'Mardi',
  [WeekDaysEnum.Wednesday]: 'Mercredi',
  [WeekDaysEnum.Thursday]: 'Jeudi',
  [WeekDaysEnum.Friday]: 'Vendredi',
  [WeekDaysEnum.Saturday]: 'Samedi',
  [WeekDaysEnum.Sunday]: 'Dimanche',
};
